<script lang="ts" setup>
import type { CategoryTree } from "~~/models/categories";
import type { CatalogPageRecord } from "~~/server/graphql/datocms/generated";
import type { PlanktonCategoryWithSlugs } from "~~/server/plankton";

defineProps<{
  viewMode: "list" | "details";
  cmsData: CatalogPageRecord;
  categoryTree: CategoryTree;
  category?: PlanktonCategoryWithSlugs | null | undefined;
}>();

const { locale } = useI18n();

const { data: productGroupData } = await useFetch("/api/cms/product-groups", {
  query: {
    locale: locale,
  },
});
</script>

<template>
  <div class="py-sm md:py-lg gap-md flex flex-col justify-between border-b border-neutral-100 md:flex-row md:items-center">
    <div class="flex justify-center md:hidden">
      <HeaderStore />
    </div>

    <div class="gap-md flex flex-wrap items-center">
      <div class="hidden lg:block">
        <ProductCategoryMenuDesktop
          :cms-data="cmsData as CatalogPageRecord"
          :category-tree="categoryTree"
          :product-groups="productGroupData?.allProductGroups"
        />
      </div>

      <div class="block w-full lg:hidden">
        <ProductCategoryMenuMobile
          :cms-data="cmsData as CatalogPageRecord"
          :category-tree="categoryTree"
          :product-groups="productGroupData?.allProductGroups"
        />
      </div>

      <ProductCatalogBreadcrumbs :view-mode="viewMode" :category-tree="categoryTree" :category="category" />
    </div>

    <div class="hidden md:block">
      <HeaderStore />
    </div>
  </div>
</template>

<style scoped>

</style>
